import type { SubjectStatus } from '../db/schema';

const LABELS: Record<SubjectStatus, string> = {
  not_photographed: 'Not photographed',
  photographed: 'Photographed',
  excluded: 'Excluded'
};

/**
 * Status is always conveyed by an icon + text label together, never colour
 * alone (spec: "distinguish states without relying only on colour").
 */
export function StatusBadge({ status, warning }: { status: SubjectStatus; warning?: boolean }) {
  const icon = status === 'photographed' ? '✓' : status === 'excluded' ? '—' : warning ? '!' : '○';
  return (
    <span className={`status-badge status-badge--${status}${warning ? ' status-badge--warning' : ''}`}>
      <span aria-hidden="true" className="status-badge-icon">
        {icon}
      </span>
      {LABELS[status]}
      {warning && ' · needs review'}
    </span>
  );
}
